module.exports = __webpack_public_path__ + "img/genswell_2_2.8a967bfa.png";